import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.css";

const CourseCard = ({
  courseData,
  activeTab,
  setSelectedCourse,
  openViewCourse,
  setViewCourseType,
  setShowConfirmationModal,
}) => {
  const [showOtherOptions, setShowOtherOptions] = useState(false);
  const otherOptionsRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (otherOptionsRef.current && !otherOptionsRef.current.contains(e.target)) {
        setShowOtherOptions(false);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleAction = (type) => {
    setSelectedCourse(courseData);
    if (type === "View" || type === "Edit") {
      openViewCourse(true);
      setViewCourseType(type);
    } else if (type === "Delete") {
      setShowConfirmationModal(true);
    }
    setShowOtherOptions(false);
  };

  const isVerified = courseData.isVerified;

  return (
    <div className={styles.courseCard}>
      {/* Upper Section: Image & Status Badge */}
      <div className={styles.imageSection}>
        <img
          className={styles.flag}
          src={
            (typeof courseData.courseImage === "string" ? courseData.courseImage : courseData.courseImage?.data) ||
            (typeof courseData.coverImage === "string" ? courseData.coverImage : courseData.coverImage?.data) ||
            "https://via.placeholder.com/150"
          }
          alt="course_img"
        />
        {activeTab === "Courses" && (
          <div className={`${styles.badge} ${isVerified ? styles.badgeVerified : styles.badgePending}`}>
            {isVerified ? (
              <>
                Verified <i className="fa-solid fa-circle-check"></i>
              </>
            ) : (
              <>Pending Verification</>
            )}
          </div>
        )}
      </div>

      {/* Middle Section: Details */}
      <div className={styles.infoSection}>
        <div className={styles.cardHeader}>
          <h3 className={styles.courseTitle}>
            {courseData.title?.data ||
              (typeof courseData.title === "string" ? courseData.title : "Untitled Lesson")}
          </h3>
          <div className={styles.moreOptions} ref={otherOptionsRef}>
            <i
              className={`${styles.moreOptionsIcon} fas fa-ellipsis-h`}
              onClick={(e) => {
                e.stopPropagation();
                setShowOtherOptions((prev) => !prev);
              }}
            ></i>
            <ul className={`${styles.otherOptions} ${showOtherOptions ? styles.showOptions : ""}`}>
              {["View", "Edit", "Delete"].map((action) => (
                <li key={action} onClick={() => handleAction(action)}>
                  <span>{action}</span>{" "}
                  <i
                    className={
                      action === "View"
                        ? "fas fa-eye"
                        : action === "Edit"
                          ? "fas fa-pencil"
                          : "fas fa-trash"
                    }
                  ></i>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className={styles.description}>
          {courseData.description?.data ||
            (typeof courseData.description === "string" ? courseData.description : "No description provided.")}
        </p>

        <div className={styles.metaRow}>
          <div className={styles.metaItem}>
            <i className="fas fa-book-open"></i>
            <span>{activeTab}</span>
          </div>
        </div>
      </div>

      {/* Lower Section: Action Buttons */}
      <div className={styles.menuBtns}>
        <button className={styles.btn} onClick={() => handleAction("View")}>
          <i className="fas fa-eye"></i>
          <span>View</span>
        </button>
        <button className={styles.btn} onClick={() => handleAction("Edit")}>
          <i className="fas fa-pencil"></i>
          <span>Edit</span>
        </button>
        <button className={`${styles.btn} ${styles.btnDelete}`} onClick={() => handleAction("Delete")}>
          <i className="fas fa-trash"></i>
          <span>Delete</span>
        </button>
      </div>
    </div>
  );
};

export default CourseCard;
